"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var helpers_1 = require("../../helpers");
function init(date, livestream, event) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (event === void 0) { event = {}; }
    var model = {
        title: (_a = event.title) !== null && _a !== void 0 ? _a : '',
        channel_id: (_b = event.channel_id) !== null && _b !== void 0 ? _b : livestream.channel_id,
        livestream_id: (_c = event.livestream_id) !== null && _c !== void 0 ? _c : livestream.livestream_id,
        start: (_d = event.start) !== null && _d !== void 0 ? _d : '',
        end: (_e = event.end) !== null && _e !== void 0 ? _e : '',
        team_id: (_f = event.team_id) !== null && _f !== void 0 ? _f : '',
        opponent_id: (_g = event.opponent_id) !== null && _g !== void 0 ? _g : '',
        match_location: (_h = event.match_location) !== null && _h !== void 0 ? _h : '',
    };
    if (event.id) {
        model.id = event.id;
    }
    return model;
}
function Save(_a) {
    var _b = _a.current, current = _b === void 0 ? {} : _b, livestream = _a.livestream, date = _a.date, events = _a.events, setEvents = _a.setEvents, onSuccess = _a.onSuccess, channel = _a.channel;
    var _c = react_1.useState(), end = _c[0], setEnd = _c[1];
    var _d = react_1.useState(), start = _d[0], setStart = _d[1];
    var _e = storybook_1.Helpers.useSave('media', 'events', init(date, livestream, current), {}, {}, setEvents, events.data), event = _e[0], setEvent = _e[1], submitEvent = _e[2];
    var beginEnd = new Date(event.data.end);
    var beginStart = new Date(event.data.start);
    react_1.useEffect(function () {
        setEnd(beginEnd.toLocaleTimeString());
        setStart(beginStart.toLocaleTimeString());
    }, []);
    function replaceSlash(date, time) {
        var newDate;
        if (time.length > 6) {
            newDate = helpers_1.toMMDDYY(date) + 'T' + time;
        }
        else {
            newDate = helpers_1.toMMDDYY(date) + 'T' + time + ':00';
        }
        return newDate.replace(/\//g, '-');
    }
    function onSubmit() {
        event.data.end = replaceSlash(date, end);
        event.data.start = replaceSlash(date, start);
        submitEvent().then(function (response) {
            if (!response.errors.length) {
                onSuccess();
            }
        });
    }
    return react_1.default.createElement("div", { className: 'storybook-events-create-form' },
        react_1.default.createElement("div", null,
            react_1.default.createElement(storybook_1.Forms.Thumbnail, { image: event.data.thumbnail || current.thumbnail, icon: 'camera', onChange: function (thumbnail) { return setEvent({ thumbnail: thumbnail }); }, label: 'Banner vervangen' })),
        react_1.default.createElement("div", { className: 'storybook-events-edit' },
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Label, null, "Titel event"),
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'text', name: 'title', value: event.data.title, placeholder: 'Titel van het event', onChange: function (title) { return setEvent({ title: title }); } })),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Label, null, "Starttijd"),
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'time', name: 'date-time', value: start, onChange: function (start) { return setStart(start); } })),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Label, null, "Eindtijd"),
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'time', name: 'date-time-end', value: end, onChange: function (end) { return setEnd(end); } })),
            react_1.default.createElement(storybook_1.Livestreams.Match, { simple: true, video: event.data, setVideo: function (video) {
                    setEvent(video);
                }, channel: channel }),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Buttons, { loading: event.submitting, errors: event.errors },
                    react_1.default.createElement("div", { className: 'storybook-events-save-buttons' },
                        current.external_id && react_1.default.createElement(storybook_1.Texts.Small, { className: 'text-gray-400 mr-2' },
                            "Event id: ",
                            current.external_id),
                        event.data.id && react_1.default.createElement(storybook_1.Events.Destroy, { event: event, events: events, setEvents: setEvents, onSuccess: onSuccess }),
                        react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', icon: 'check', disabled: event.submitting, onClick: onSubmit }))))));
}
exports.default = Save;
